import * as React from "react";
import { AlertCircle, CheckCircle2, Info } from "lucide-react";
import { cn } from "@/lib/utils";

type AlertVariant = "info" | "warning" | "danger" | "success";

const alertStyles: Record<AlertVariant, string> = {
  info: "border-primary/25 bg-primary/5 text-ink",
  warning: "border-payable/30 bg-warning-bg text-ink",
  danger: "border-danger/30 bg-danger-bg text-ink",
  success: "border-credit/30 bg-credit/10 text-ink",
};

const icons = {
  info: Info,
  warning: AlertCircle,
  danger: AlertCircle,
  success: CheckCircle2,
};

export function Alert({
  variant = "info",
  title,
  children,
  className,
}: React.HTMLAttributes<HTMLDivElement> & { variant?: AlertVariant; title?: string }) {
  const Icon = icons[variant];
  return (
    <div className={cn("flex gap-3 rounded-lg border p-3 text-sm leading-6", alertStyles[variant], className)}>
      <Icon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <div className="min-w-0">
        {title ? <p className="font-semibold text-ink">{title}</p> : null}
        <div className="text-muted">{children}</div>
      </div>
    </div>
  );
}
